import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';
import { ExtraBold } from './Text';

const SubMenuContainer = styled.div`
  	display: flex;
	width: 90%;
	height: 60px;
	max-width: 900px;
	flex-direction: row;
	gap: 0;
`;

const SubMenuItem = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-bottom: ${ (props) => ( props.isSelected ? `3px solid ${ FONT.default }` : 'none' )};
`;


export default function SubMenu(props) {
  	return (
		<SubMenuContainer>
			{
				props.categories.map((menu, index) => (
					<SubMenuItem key={ index }
						isSelected={ props.selectedMenu === index }
						onClick={ () => props.setSelectedMenu(index) }
					>
						<ExtraBold size='28px'>{ menu }</ExtraBold>
					</SubMenuItem>
				))
			}
		</SubMenuContainer>
  	);
}
